import { ChevronRightIcon, HomeIcon } from "@heroicons/react/outline";
import { BreadcrumbsType, useBreadcrumb } from "@refinedev/core";
import { DropdownMenu } from "components/dropdownMenu";
import { isEmpty } from "lodash";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { isHaveActionPermission } from "utills/helpers";

interface BreadcrumbProps {
  type?: string;
  breadcrumbItems?: BreadcrumbsType[];
  title?: string;
  disableBorder?: boolean;
  additionalLabel?: ReactNode;
  customPageLabel?: string;
  className?: string;
}

export const Breadcrumbs = (props: BreadcrumbProps) => {
  const { breadcrumbs } = useBreadcrumb();
  const { breadcrumbItems = [], additionalLabel, customPageLabel, type, className } = props;

  const breadcrumbArr = (!isEmpty(breadcrumbItems) ? breadcrumbItems : breadcrumbs) ?? [];

  const breadcrumbDropdownMenu =
    (breadcrumbArr ?? []).filter(
      (breadcrumb, index) => breadcrumb.href && index !== breadcrumbArr.length - 1
    ) ?? [];

  return (
    <div className={twMerge("w-full flex items-center justify-between flex-wrap gap-3 sm:gap-4", type === "wps" ? "pt-4 px-4": "", className)} aria-label="Breadcrumb">
      <div className="capitalize inline-flex items-center max-w-full">
        <Link
          to="/dashboard/overview"
          onClick={(e) => {
            if (!isHaveActionPermission("", "dashboard", "view")) {
              e.preventDefault();
            }
          }}
          className="flex items-center justify-center size-14 rounded-full bg-magnolia-600 z-0 text-sm font-medium shadow-[2px_0_5px_0_rgba(0,0,0,0.15)] hover:text-brand-500"
        >
          <HomeIcon className="size-6 flex-shrink-0 text-brand-500" />
        </Link>
        <div className="bg-white px-8 py-3 flex items-center -ml-4 rounded-r-full shadow-[2px_2px_5px_0_rgba(0,0,0,0.15)] flex-1 overflow-hidden overflow-x-auto">
          {/* Dropdown menu for mobile */}
          {breadcrumbDropdownMenu.length > 0 ? (
            <div className="flex items-center sm:hidden">
              <DropdownMenu
                position="bottom-start"
                label={<span>...</span>}
                items={breadcrumbDropdownMenu.map(({ label, href }) => ({
                  label,
                  href,
                }))}
              />
              <ChevronRightIcon className="size-3 mx-2.5" aria-hidden="true" />
            </div>
          ) : (
            <></>
          )}

          {breadcrumbArr.map(({ label, href }, index) =>
            index === breadcrumbArr.length - 1 ? (
              <Fragment key={index}>
                {href ? (
                  <Link
                    className="text-xs sm:text-sm font-medium text-[#2B3033] hover:text-brand-500"
                    to={href}
                  >
                    {customPageLabel || label}
                  </Link>
                ) : (
                  <p
                    className={`text-xs sm:text-sm font-medium text-[#2B3033]`}
                  >
                    {customPageLabel || (label === "Show" ? "Detail" : label)}
                  </p>
                )}
              </Fragment>
            ) : (
              <div key={label} className="hidden sm:block">
                <div className="flex items-center capitalize">
                  {href ? (
                    <Link
                      className="text-xs sm:text-sm font-medium text-[#868E95] hover:text-brand-500"
                      to={href}
                    >
                      {label}
                    </Link>
                  ) : (
                    <p
                      className={`text-xs sm:text-sm font-medium text-[#868E95]`}
                    >
                      {label === "Show" ? "Detail" : label}
                    </p>
                  )}
                  <ChevronRightIcon
                    className="size-3 mx-2.5"
                    aria-hidden="true"
                  />
                </div>
              </div>
            )
          )}
        </div>
      </div>
      {additionalLabel ? (
        <div className="flex-1 flex justify-end">
          {additionalLabel}
        </div>
      ) : <></>}
    </div>
  );
};
